import React, { useRef, useEffect, useState } from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import AdapterDateFns from '@date-io/date-fns'
import { Box, Button, TextField } from '@mui/material'
import { LocalizationProvider, StaticDatePicker } from '@mui/lab'
import { useStyles } from './style'
import { AppButton } from '../../components'

function CustomDatePicker(props) {
  const classes = useStyles()
  const outerRef = useRef()
  const [date, setDate] = useState(props.value || new Date())

  const handleOuterClick = (e) => {
    if (!outerRef.current.contains(e.target)) {
      props.handleCancel()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleOuterClick)

    return () => {
      document.removeEventListener('mousedown', handleOuterClick)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleDoneClick = () => {
    const obj = {
      date: date,
    }
    props.handleDone(obj)
  }

  const FormikDatePicker = () => {
    return (
      <StaticDatePicker
        views={['day']}
        showToolbar={false}
        displayStaticWrapperAs="desktop"
        disableFuture
        inputFormat="dd-MM-yyyy"
        onChange={(value) => {
          setDate(value)
        }}
        value={moment(date)}
        invalidLabel=''
        animateYearScrolling={false}
      />
    )
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box className={classes.root} ref={outerRef}>
        <Box className={classes.calendarWrapper}>
          <Box>{FormikDatePicker()}</Box>
        </Box>
        <Box className={classes.buttonGroup}>
          <Button onClick={props.handleCancel}>Reset</Button>
          <Button className={classes.button} onClick={handleDoneClick}>Done</Button>
        </Box>
      </Box>
    </LocalizationProvider>
  )
}

CustomDatePicker.defaultProps = {
  handleCancel: () => { },
  handleDone: () => { },
  value: '',
  format: '',
}

export default CustomDatePicker